var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:url(#b);}.d{fill:url(#c);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    transform: "translate(1017 399)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffde00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe59a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffd5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-1017 -399)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1017 399)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.436,5.742H2.871V7.178a1.436,1.436,0,0,0,2.871,0V5.742H7.178a1.436,1.436,0,0,0,0-2.871H5.742V1.436a1.436,1.436,0,0,0-2.871,0V2.871H1.436a1.436,1.436,0,0,0,0,2.871Zm40.387,0h1.436V7.178a1.436,1.436,0,0,0,2.871,0V5.742h1.436a1.436,1.436,0,0,0,0-2.871H46.129V1.436a1.436,1.436,0,0,0-2.871,0V2.871H41.822a1.436,1.436,0,0,0,0,2.871ZM7.178,43.258H5.742V41.822a1.436,1.436,0,0,0-2.871,0v1.436H1.436a1.436,1.436,0,0,0,0,2.871H2.871v1.436a1.436,1.436,0,0,0,2.871,0V46.129H7.178a1.436,1.436,0,0,0,0-2.871Zm33.6-4.506a21.687,21.687,0,0,0,5.275-12.817l-2.8-1.436,2.8-1.436a21.687,21.687,0,0,0-5.275-12.817l-2.15.119.12-2.149A21.684,21.684,0,0,0,25.936,2.944L24.5,5.742l-1.436-2.8A21.686,21.686,0,0,0,10.249,8.218l.12,2.149-2.15-.119A21.687,21.687,0,0,0,2.944,23.064l2.8,1.436-2.8,1.436A21.687,21.687,0,0,0,8.219,38.752l2.15-.119-.12,2.149a21.684,21.684,0,0,0,12.816,5.274l1.435-2.8,1.436,2.8a21.686,21.686,0,0,0,12.816-5.274l-.12-2.149Zm6.783,4.506H46.129V41.822a1.436,1.436,0,0,0-2.871,0v1.436H41.822a1.436,1.436,0,0,0,0,2.871h1.436v1.436a1.436,1.436,0,0,0,2.871,0V46.129h1.436a1.436,1.436,0,0,0,0-2.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7.178,23.064H2.944c-.032.477-.073.951-.073,1.436s.041.959.073,1.436H7.178a1.436,1.436,0,0,0,0-2.871Zm6.062-9.826a1.435,1.435,0,0,0,0-2.03l-2.991-2.99a21.688,21.688,0,0,0-2.03,2.03l2.991,2.99A1.435,1.435,0,0,0,13.24,13.238ZM24.5,8.613a1.435,1.435,0,0,0,1.436-1.436V2.944c-.477-.032-.951-.073-1.436-.073s-.959.041-1.436.073V7.178A1.435,1.435,0,0,0,24.5,8.613Zm13.29,4.625,2.991-2.99a21.688,21.688,0,0,0-2.03-2.03l-2.991,2.99a1.435,1.435,0,1,0,2.03,2.03ZM24.5,11.484A13.016,13.016,0,1,0,37.516,24.5,13.1,13.1,0,0,0,24.5,11.484Zm6.463,12.268-2.19,2.135.519,3.016a1.436,1.436,0,0,1-2.083,1.513L24.5,28.993l-2.708,1.423A1.436,1.436,0,0,1,19.708,28.9l.519-3.016-2.19-2.135a1.434,1.434,0,0,1,.793-2.448l3.028-.44,1.354-2.742a1.493,1.493,0,0,1,2.574,0l1.354,2.742,3.028.44a1.434,1.434,0,0,1,.793,2.448Zm4.8,12.009a1.435,1.435,0,0,0,0,2.03l2.991,2.99a21.688,21.688,0,0,0,2.03-2.03l-2.991-2.99a1.435,1.435,0,0,0-2.03,0Zm-24.551,0-2.991,2.99a21.688,21.688,0,0,0,2.03,2.03l2.991-2.99a1.435,1.435,0,0,0-2.03-2.03Zm34.847-12.7H41.822a1.436,1.436,0,0,0,0,2.871h4.234c.032-.477.073-.951.073-1.436s-.041-.959-.073-1.436ZM24.5,40.387a1.435,1.435,0,0,0-1.436,1.436v4.234c.477.032.951.073,1.436.073s.959-.041,1.436-.073V41.822A1.435,1.435,0,0,0,24.5,40.387Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3622ba7987c130bf91cdb8962fc43ab5.svg";
export { ForwardRef as ReactComponent };